module.exports = __webpack_public_path__ + "img/Map.51da8ce9.png";